import React, { useState, useEffect } from 'react';
import TippyWrapper from '../TippyWrapper';
import BarLoader from 'react-spinners/BarLoader';
import ContestantTooltip from './ContestantTooltip';
import { fetchUserStats } from '../../src/js/lib/users';

const Contestant = ({ contestant, userId }) => {
  const [showTooltipData, setShowTooltipData] = useState(false);
  const [contestantTippyData, setContestantTippyData] = useState(null);

  useEffect(() => {
    if (showTooltipData && !contestantTippyData) {
      // Fetch additional data for the contestant to show in the tooltip
      const loadUserData = async () => {
        try {
          const userData = await fetchUserStats(contestant.user_id);
          setContestantTippyData(userData);
        } catch (error) {
          console.error('Error fetching user stats:', error);
          // Set empty data to prevent infinite loading
          setContestantTippyData(null);
        }
      };

      loadUserData();
    }
  }, [showTooltipData, contestantTippyData, contestant.user_id]);

  return (
    <TippyWrapper
      content={
        showTooltipData ? (
          contestantTippyData ? (
            <ContestantTooltip
              contestant={contestantTippyData}
              allowFollow={contestant.user_id !== userId}
            />
          ) : (
            <BarLoader color='#FFFFFF' />
          )
        ) : null
      }
      placement='bottom'
      useMobileFallback={true}
      mobileClose={() => {
        setShowTooltipData(false);
        setContestantTippyData(null);
      }}
    >
      <span
        role='button'
        className='underline'
        onMouseEnter={() => setShowTooltipData(true)}
        onClick={() => setShowTooltipData(true)}
      >
        {contestant.user.name}
      </span>
    </TippyWrapper>
  );
};

export default Contestant;
